import { useContext } from "react";
import { GenerationContext } from "../providers/generationContext";

const useGeneration = () => {
  const context = useContext(GenerationContext);
  if (!context) {
    throw new Error("useGeneration must be used within a GenerationProvider");
  }
  return context;
};

export default useGeneration;
